import type { Route } from "./+types/tour-schedule.ts"

import { Res } from "@iyk/vf-server"
import { Array, Effect } from "effect"
import { Handler } from "../../../server/handler.ts"
import { BackToProfileButton } from "../ui/back-to-profile-button.tsx"
import { ShowScheduleItem, ShowScheduleLink } from "../ui/show-schedule-item.tsx"

export const loader = Handler.make("profile-tour-schedule", ({ api, clock }) => {
  return Effect.gen(function* () {
    const shows = yield* api.listShows
    const now = yield* clock.today

    const [pastShows, upcomingShows] = Array.partition(shows, (show) => show.date >= now)

    return Res.json({ upcomingShows, pastShows })
  })
})

export default function ProfileTourSchedule(props: Route.ComponentProps) {
  const attendedShowIds = props.matches[1].data.user?.attendedShowIds || []

  return (
    <div className="flex flex-col gap-6 px-4 pt-4">
      <BackToProfileButton />
      <div className="flex flex-col gap-3">
        {props.loaderData.upcomingShows.map((show) => (
          <ShowScheduleLink
            key={show.id}
            id={show.id}
            month={show.month}
            dayOfMonth={show.dayOfMonth}
            dayOfWeek={show.dayOfWeek}
            time={show.time}
            venue={show.venue}
            city={show.city}
            state={show.state}
            url={show.url}
            checked={attendedShowIds.includes(show.id)}
          />
        ))}

        <h3 className="text-sm mt-2">Past dates</h3>
        {props.loaderData.pastShows.map((show) => (
          <ShowScheduleItem
            key={show.id}
            id={show.id}
            month={show.month}
            dayOfMonth={show.dayOfMonth}
            dayOfWeek={show.dayOfWeek}
            time={show.time}
            venue={show.venue}
            city={show.city}
            state={show.state}
            checked={attendedShowIds.includes(show.id)}
          />
        ))}
      </div>
    </div>
  )
}
